export default __webpack_public_path__ + "static/media/format_bold.b092d07d.svg";